function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Slider v1.1.1
 *
 * Copyright brandung GmbH & Co.KG
 *
 * Date: 2019-12-17
 * MIT License (MIT)
 *
 * @see http://idangero.us/swiper/api/
 */
import { Swiper, Navigation, Pagination, Autoplay, Lazy } from 'swiper/js/swiper.esm.js';
Swiper.use([Navigation, Pagination, Lazy, Autoplay]);
import Capitan from '../../code/js/Capitan/Capitan';
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
var _ = {
  defaults: {
    componentSelector: '.swiper',
    destroyMobile: 'swiper-type-mobile-only',
    swiperAppGalery: 'swiper--app-galery',
    hasLoop: 'swiper-loop',
    hasAutoplay: 'swiper-autoplay',
    paginationSettings: {
      paginationSelector: '.swiper-controls .swiper-pagination',
      bullets: {
        type: 'bullets',
        clickable: true,
        renderBullet: function renderBullet(index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      }
    },
    classes: {
      active: 'is-active',
      static: 'is-static'
    }
  }
};
var o = _.defaults;
var swiper = [];

function destroySwiper() {
  // console.log('DESTROYING', await fetch(swiper).then(data => data.text()));
  // Clean up old instances and styles when available
  // Iterate over all sliders
  return Promise.all(swiper.map(function (component) {
    return new Promise(function (resolve, reject) {
      // Get correct settings or set default settings
      component !== undefined && !component.destroyed && component.$el && component.$el.length > 0 && component.$el[0].classList.contains(o.destroyMobile) && component.destroy(true, true);
      resolve();
    });
  }));
}

function getSettings(sliderClass, paginationStyle) {
  //   console.log("sliderclass", sliderClass)
  var settings = {
    direction: 'horizontal',
    // It's important to set slidesPerView to 'auto' when using columns
    slidesPerView: 'auto',
    centerSlides: true,
    longSwipesRatio: 0.25,
    roundLengths: true,
    preloadImages: true,
    observer: true,
    watchOverflow: false,
    draggable: true,
    lazy: true,
    updateOnImagesReady: false,
    spaceBetween: document.querySelector(sliderClass).classList.contains(o.swiperAppGalery) ? 2 : 5,
    mousewheel: true,
    touchEventsTarget: 'wrapper',
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    a11y: {
      prevSlideMessage: 'Vorheriger Slide',
      nextSlideMessage: 'Nächster Slide'
    },
    navigation: {
      nextEl: sliderClass + ' .swiper-button-next',
      prevEl: sliderClass + ' .swiper-button-prev'
    },
    pagination: _objectSpread({
      el: sliderClass + ' ' + o.paginationSettings.paginationSelector
    }, o.paginationSettings[paginationStyle]),
    on: {
      init: function init() {
        this.el.classList.add('is-init');
      }
    },
    loop: document.querySelector(sliderClass).classList.contains(o.hasLoop),
    autoplay: document.querySelector(sliderClass).classList.contains(o.hasAutoplay)
  };
  return settings;
}

function definePagination(target) {
  var paginationClass = document.querySelector("".concat(target, " > ").concat(o.paginationSettings.paginationSelector));
  return paginationClass && paginationClass.dataset.pagination;
}
/**
 * @summary Adds static class to pagination when number of bullets is smaller than dynamic main bullets. This seems to be a bug in swiper.js.
 * @param {*} target Target Swiper
 */


function defineDynamicBullets(target) {
  var bulletNumber = document.querySelector("".concat(target, " > ").concat(o.paginationSettings.paginationSelector));
  if (!bulletNumber) return;

  if (bulletNumber.children.length < o.paginationSettings.bullets.dynamicMainBullets) {
    // console.log('STATIC');
    bulletNumber.classList.add(o.classes.static);
  } else {
    bulletNumber.classList.remove(o.classes.static);
  }
}

function reinitDestroyedSwiper() {
  var components = _toConsumableArray(document.querySelectorAll(".".concat(o.destroyMobile)));

  var current = ".".concat(o.destroyMobile); // Iterate over all sliders

  components.forEach( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(component, index) {
      var settings, swiperSettings;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import("./settings/".concat(getSwiperType(component), ".json"));

            case 2:
              settings = _context.sent;
              // Override default and/or set settings
              swiperSettings = Object.assign(getSettings(current, definePagination(current)), _objectSpread({}, settings.default)); // Create the swiper with given class and settings and push it onto the array of swipers

              createSwiper(current, swiperSettings);
              defineDynamicBullets(current);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

function createSwiper(classname, options) {
  // Create new swiper with settings
  var swiperInstance = new Swiper(classname, options);
  var autoplayController = document.querySelector(classname);

  if (autoplayController.classList.contains(o.hasAutoplay)) {
    autoplayController.addEventListener('mouseover', function () {
      return swiperInstance.autoplay.stop();
    });
    autoplayController.addEventListener('mouseleave', function () {
      return swiperInstance.autoplay.start();
    });
  }

  swiper.push(swiperInstance);
  return swiperInstance;
}

function getSwiperType(component) {
  // Give the swiper-container a swiper-type-<TYPE> class and filter for it
  var swiperTypeRegex = /swiper-type-(?=\S*)([a-zA-Z'-]+)/gm; // Execute the regex string from above on the components classlist

  var swiperClasses = swiperTypeRegex.exec(component.getAttribute('class')); // Return the swiper-type if it's available, otherwise return 'default'

  var swiperType = swiperClasses ? swiperClasses[1] : 'default';
  return swiperType;
}

function onResize() {
  return _onResize.apply(this, arguments);
}

function _onResize() {
  _onResize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!Capitan.assertBreakpoint('ht', 'md')) {
              _context2.next = 4;
              break;
            }

            destroySwiper();
            _context2.next = 7;
            break;

          case 4:
            _context2.next = 6;
            return destroySwiper();

          case 6:
            reinitDestroyedSwiper();

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _onResize.apply(this, arguments);
}

export function init() {
  return _init.apply(this, arguments);
}

function _init() {
  _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var components, _loop, i, _ret;

    return regeneratorRuntime.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!document.querySelector(o.componentSelector)) {
              _context4.next = 14;
              break;
            }

            // console.log('swiper init');
            CapSmartResize(onResize, 100, false); // Grab all swipers on a page

            components = _toConsumableArray(document.querySelectorAll(o.componentSelector));
            _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
              var component, index, swiperClass, current, settings, swiperSettings, swiper;
              return regeneratorRuntime.wrap(function _loop$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      component = components[i];

                      if (!component.classList.contains("customer-module--swiper")) {
                        _context3.next = 3;
                        break;
                      }

                      return _context3.abrupt("return", "continue");

                    case 3:
                      if (!component.classList.contains("customer-bar--autoplay")) {
                        _context3.next = 5;
                        break;
                      }

                      return _context3.abrupt("return", "continue");

                    case 5:
                      index = i; // Create a new class + index

                      swiperClass = "swiper-".concat(index); // Add this newly created class to the swiper's classList

                      component.classList.add(swiperClass); // Add a dot in front of the class and assign it to current

                      current = ".".concat(swiperClass); // Get correct settings or set default settings

                      _context3.next = 11;
                      return import("./settings/".concat(getSwiperType(component), ".json"));

                    case 11:
                      settings = _context3.sent;
                      //   console.log(`${getSwiperType(component)}`);
                      // Override default and/or set settings
                      swiperSettings = Object.assign(getSettings(current, definePagination(current)), _objectSpread({}, settings.default)); //   console.log(swiperSettings);
                      // Create the swiper with given class and settings and push it onto the array of swipers

                      swiper = createSwiper(current, swiperSettings);

                      if (getSwiperType(component) === 'anchor') {
                        import(
                        /* webpackChunkName: "anchor-nav" */
                        '../anchor-nav/anchor-nav').then(function (module) {
                          var anchorNav = component.closest('.anchor-nav');
                          module.init(anchorNav, swiper);
                        });
                      }

                      defineDynamicBullets(current);

                    case 16:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _loop);
            });
            i = 0;

          case 5:
            if (!(i < components.length)) {
              _context4.next = 13;
              break;
            }

            return _context4.delegateYield(_loop(i), "t0", 7);

          case 7:
            _ret = _context4.t0;

            if (!(_ret === "continue")) {
              _context4.next = 10;
              break;
            }

            return _context4.abrupt("continue", 10);

          case 10:
            i++;
            _context4.next = 5;
            break;

          case 13:
            // kickstart the resizing monitoring
            onResize();

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _init.apply(this, arguments);
}